export default {
  loading: false,
  forms: [],
  form: {},
  totalCount: 0,
  stamps: [],
  stampsTotalCount: 0
};
